import { render, staticRenderFns } from "./aside-menu2.vue?vue&type=template&id=7fa5fcfd&"
import script from "./aside-menu2.vue?vue&type=script&lang=js&"
export * from "./aside-menu2.vue?vue&type=script&lang=js&"
import style0 from "./aside-menu2.vue?vue&type=style&index=0&id=7fa5fcfd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports